import type { PathChoice } from '@/types'

const PATH_EVENT = 'dm:choose-path'
const STORAGE_KEY = 'dm:chosen-path'
const PATHS: Array<PathChoice> = ['launch', 'scale', 'unsure', 'fix']

export const isPathChoice = (value: unknown): value is PathChoice => typeof value === 'string' && PATHS.includes(value as PathChoice)

export const choosePath = (path: PathChoice): void => {
    if (typeof window === 'undefined') return

    try {
        window.sessionStorage.setItem(STORAGE_KEY, path)
    }

    catch {
        // Storage can be unavailable (private mode). The live event below still works.
    }

    window.dispatchEvent(new CustomEvent<PathChoice>(PATH_EVENT, { detail: path }))
}

export const takeStoredPath = (): PathChoice | null => {
    if (typeof window === 'undefined') return null

    try {
        const stored = window.sessionStorage.getItem(STORAGE_KEY)

        window.sessionStorage.removeItem(STORAGE_KEY)

        return isPathChoice(stored) ? stored : null
    }

    catch {
        return null
    }
}

export const onPathChosen = (handler: (path: PathChoice) => void): (() => void) => {
    const listener = (event: Event) => {
        const detail = (event as CustomEvent<unknown>).detail

        if (!isPathChoice(detail)) return

        try {
            window.sessionStorage.removeItem(STORAGE_KEY)
        }

        catch {
            // Ignore storage errors.
        }

        handler(detail)
    }

    window.addEventListener(PATH_EVENT, listener)

    return () => window.removeEventListener(PATH_EVENT, listener)
}
